<template>
  <div class="input-cengter-dialog">
    <el-button type="info"   :loading="inputLoading" :size="size" @click="inputExe">
      <!-- 上传按钮 -->
      <input
        name="files"
        style="display: none"
        type="file"
        ref="file"
        :multiple="false"
        :accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
        @change="fileChange($event)"
      />
      {{ inputText }}
    </el-button>
    <el-button type="info"   :loading="downLoadLoading" :size="size" @click="downModel"> {{ $lang('下载模板') }}</el-button>
    <el-button type="info"  :size="size" @click="inputPriview"> {{ $lang('导入预览') }}</el-button>
    <el-dialog
      class="network-download-dialog"
      width="80%"
      lock-scroll
      custom-class="input-data"
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('导入数据')"
      :close-on-click-modal="false"
      :visible.sync="boxVisibleInport"
      @close="close"
    >
      <el-tabs v-model="downActiveName" @tab-click="handleClick">
        <el-tab-pane name="first">
          <span slot="label">
            {{ $lang('导入成功') }}<span class="all-count">({{ inputInfo.succNum || 0 }})</span>
          </span>
          <el-button type="info" :loading="downLoadingSuccessFail" style="margin-bottom: 10px" @click="downLoadExecl(1)">{{ $lang('下载成功文件') }}</el-button>
          <inputForm ref="successInput" :IPUT_FORM="DOWN_HTTP" :params="params" :column="column.filter((o) => !o.successDisplay)" />
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label">
            {{ $lang('导入失败') }}<span class="all-count">({{ inputInfo.failNum || 0 }})</span>
          </span>
          <el-button type="info" :loading="downLoadingSuccessFail" style="margin-bottom: 10px" @click="downLoadExecl(2)">{{ $lang('下载失败文件') }}</el-button>
          <inputForm :IPUT_FORM="DOWN_HTTP" :column="column" :params="params" @inputInfo="inputInfoFn" ref="failInput" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { RESPONSE_CODE } from '@public/http/config'
import inputForm from './inputForm.vue'
import { hasPower } from '@public/utils/common'
const handleRouteName = (name, { moduleCode = '' } = {}) => (moduleCode ? `${name}|${moduleCode}` : name)
export default {
  name: 'InputVenterDialog',
  components: { inputForm },
  props: {
    inputTextNew: {
      type: String,
      default: '批量新增'
    },
    // 接口参数
    DOWN_HTTP: {
      type: Object
    },
    // 列表参数
    column: {
      type: Array,
      default: () => []
    },
    // 报表名称
    reportName: {
      type: String,
      default: ''
    },
    // 导入成功、失败文件总数字段
    inputTotal: {
      type: Object,
      default() {
        return {
          importSuccNum: 'importSuccNum',
          importFailNum: 'importFailNum'
        }
      }
    },
    // 批量新增loading延迟
    inputLoadTime: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'small'
    },
    // 混入参数
    params: {
      type: Object,
      default: () => {}
    },
    hasReview: {
      type: Boolean,
      default: true
    },
    // 按钮权限
    buttonPower: {
      type: Object,
      default() {
        return {
          Input: 'INPUT',
          Template: 'TEMPLATE',
          Preview: 'INPUT'
        }
      }
    },
    noReviewText: {
      type: String,
      default: '导入校验完成,请稍后在导入预览中查看结果'
    }
  },
  data() {
    return {
      moduleName: handleRouteName(this.$route.name, this.$route.query),
      inputText: this.$lang(`${this.inputTextNew}`),
      inputLoading: false, // 批量导入
      downLoadLoading: false, // 下载模板
      boxVisibleInport: false, // 导入数据
      downLoadingSuccessFail: false, // 导入导出loading
      downActiveName: 'first',
      inputInfo: {
        succNum: 0,
        failNum: 0
      } // 总数
    }
  },
  methods: {
    hasPower(type) {
      return hasPower(this.moduleName, type)
    },
    // 下载成功失败文件
    async downLoadExecl(pageType) {
      // 注册导出任务之前的钩子
      try {
        this.downLoadingSuccessFail = true
        // 调用导出方法
        const res = await this.DOWN_HTTP.reqSuccessFailExcel({ pageType, ...this.params })
        this.downLoadingSuccessFail = false
        this.downFile(res, pageType === 1 ? this.$lang(`${this.reportName}导入-成功文件`) : this.$lang(`${this.reportName}导入-失败文件`))
      } catch (error) {
        this.downLoadingSuccessFail = false
        // 重置自定义导出方法变量this.customOutExcelJobApi
        this.customOutExcelJobApi = null
      }
    },
    // 导入数据-点击导入成功导入失败
    fileChange(e) {
      this.inputLoading = true
      this.inputText = this.$lang('文件导入中请稍等...')
      this.fileList2(e.target)
      e.target.value = ''
    },
    async fileList2(fileList) {
      const files = fileList.files
      if (files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.uploadFile(files[0])
      } else {
        this.inputText = this.inputTextNew
        this.inputLoading = false
        this.$message.error(this.$lang('只能上传EXCEL文件'))
      }
    },
    async uploadFile(files) {
      try {
        const formData = new FormData()
        formData.append('uploadFile', files)
        const List = Object.keys(this.params || {})
        List.length &&
          List.map((key) => {
            key && formData.append(key, this.params[key])
          })
        const { code, msg } = await this.DOWN_HTTP.reqInputExcel(formData)
        setTimeout(() => {
          this.inputLoading = false
          this.inputText = this.inputTextNew
        }, this.inputLoadTime)
        // 2.1 异常报错
        if (code === RESPONSE_CODE.SUCCESS_COPY) {
          this.$emit('getListData')
          // this.showInputDialog()异步导入不自动打开导入预览
          this.$message.success(this.$lang(this.noReviewText))
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        this.inputText = this.inputTextNew
        this.inputLoading = false
      }
    },
    // 下载模板
    async downModel() {
      // 注册导出任务之前的钩子
      try {
        this.downLoadLoading = true
        // 调用导出方法
        const res = await this.DOWN_HTTP.templateDown()
        this.downLoadLoading = false
        this.downFile(res, this.$lang(`${this.reportName}导入模板`))
      } catch (error) {
        this.downLoadLoading = false
        console.error('outExcel::error', error)
      }
    },
    // 下载模板
    downFile(res, excelName) {
      if (res) {
        // 403和502 错误跳过
        // 请求是responseType: 'arraybuffer',错误时返回的是json
        const enc = new TextDecoder('utf-8')
        let errorData = { code: null }
        try {
          errorData = JSON.parse(enc.decode(new Uint8Array(res))) // 转化成json对象
        } catch (error) {
          // errorData.code = null
        }
        if (errorData.code) {
          if (errorData.code === 130093033) {
            this.$message.success(errorData.msg)
          } else {
            this.$message.error(errorData.msg)
          }
        } else {
          if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            // IE
            window.navigator.msSaveOrOpenBlob(res, this.$lang(this.$route.meta.title) + '.xlsx')
          } else {
            // 火狐谷歌都兼容
            const disposition = res['content-disposition']
            let suffix = '.xlsx'
            // 如果返回有content-disposition，取返回文件的后缀
            if (disposition) {
              delete res['content-disposition']
              suffix = '.' + disposition.split('filename=')[1].split('.')[1]
            }
            const url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' }))
            const elink = document.createElement('a')
            elink.style.display = 'none'
            elink.href = url
            elink.setAttribute('download', excelName + suffix)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          }
        }
      }
    },
    // 导入预览
    inputPriview() {
      this.showInputDialog()
    },
    showInputDialog() {
      this.boxVisibleInport = true
      this.downActiveName = 'first'
      setTimeout(() => {
        const { successInput, failInput } = this.$refs
        successInput.clearData()
        failInput.clearData()
        successInput.open(1)
        failInput.open(2)
      }, 100)
    },
    async inputExe() {
      // this.inputText = this.$lang('文件选择中请稍等...')
      this.$refs.file.click()
    },
    // 获取总量
    inputInfoFn(data) {
      const { importSuccNum, importFailNum } = this.inputTotal
      Object.assign(this.inputInfo, { succNum: data[importSuccNum], failNum: data[importFailNum] })
    },
    close() {
      this.boxVisible = false
    },
    /**
     * tab切换
     */
    handleClick() {
      this.$emit('inputCenterChange', this.downActiveName)
    }
  }
}
</script>
<style scoped>
.input-cengter-dialog {
  display: inline-block !important;
}
</style>
